type ApiErrorData = {
  message?: string;
  error?: string;
  errors?: Array<{ platform?: string; message?: string }>;
};

/** Best human-readable message in an RTK Query error, if any. */
export const extractApiErrorMessage = (error: unknown): string | undefined => {
  if (typeof error !== "object" || error === null || !("data" in error)) {
    return undefined;
  }
  const data = (error as { data?: ApiErrorData }).data;
  if (!data) return undefined;
  if (Array.isArray(data.errors) && data.errors.length > 0) {
    return data.errors
      .map((e) =>
        e.message
          ? `${e.platform ? `[${e.platform}] ` : ""}${e.message}`
          : JSON.stringify(e)
      )
      .join(", ");
  }
  if (typeof data.message === "string") return data.message;
  if (typeof data.error === "string") return data.error;
  return undefined;
};
